import { useEffect, useState } from 'react';
import { useAuth } from './auth-context';
import { CLOUD_BOOTSTRAP_DONE_KEY } from './cloud-sync';

function safeLocalStorageGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

/**
 * True when cloud sync has finished its first pull/push for this signed-in session,
 * or when unauthenticated. Prevents routing from localStorage before server state is merged.
 */
export function useAccountBootstrapReady(): boolean {
  const { user, loading, accessToken } = useAuth();
  const [synced, setSynced] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user || !accessToken) {
      setSynced(true);
      return;
    }
    setSynced(false);
    let cancelled = false;
    const started = Date.now();
    const maxMs = 6000;
    const id = window.setInterval(() => {
      if (cancelled) return;
      if (
        safeLocalStorageGet(CLOUD_BOOTSTRAP_DONE_KEY) === 'true' ||
        Date.now() - started > maxMs
      ) {
        setSynced(true);
        window.clearInterval(id);
      }
    }, 80);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [user, loading, accessToken]);

  if (loading) return false;
  if (!user || !accessToken) return true;
  return synced;
}
